import FileUpload from '../../../sharedComponents/FileUpload';

export default ({
  questionId,
  answers,
  setAnswers,
  hasInvalidMark
}) => {
  const answerObj =  answers[questionId] || {};
  const {
    files = []
  } = answerObj;

  const initialFiles = files.map(({ file }) => file)

  const onUpdateAnswer = (files = []) => {
    const formattedFiles = files.map(file => ({ file }))
    const updateObj = { files:  formattedFiles }
    setAnswers({
      ...answers,
      [questionId]: updateObj
    })
  }

  return (
    <div style={{ position: 'relative' }}>
      <FileUpload
        initialFiles={initialFiles}
        onFilesChanged={onUpdateAnswer}
      />
      {
        hasInvalidMark &&
        <div style={{ position: 'absolute', bottom: '-20px', fontStyle: 'italic', fontSize: '15px', color: hasInvalidMark ? '#ef0c0c' : 'inherit' }}>
          {'*Required'}
        </div>
      }
    </div>
  )
}